import { render, staticRenderFns } from "./AlertsMessagesView.vue?vue&type=template&id=8d808bac&scoped=true"
import script from "./AlertsMessagesView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlertsMessagesView.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AlertsMessagesView.vue?vue&type=style&index=0&id=8d808bac&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d808bac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d808bac')) {
      api.createRecord('8d808bac', component.options)
    } else {
      api.reload('8d808bac', component.options)
    }
    module.hot.accept("./AlertsMessagesView.vue?vue&type=template&id=8d808bac&scoped=true", function () {
      api.rerender('8d808bac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AlertsMessages/AlertsMessagesView.vue"
export default component.exports